import * as React from "react";
const SvgYogaStudio = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.093 2.017a3.501 3.501 0 0 1 2.99 2.483h7.942a2.5 2.5 0 0 1 2.479 2.175l1.473 11.217A2.75 2.75 0 0 1 19.25 21H5.278a.75.75 0 0 1-.195-.025 3.5 3.5 0 0 1-3.042-4.012L3.247 5.134v-.002a3.5 3.5 0 0 1 3.846-3.115ZM10.194 6l-.154 1.5h9.06l-.084-.63a1 1 0 0 0-.991-.87h-7.83Zm-.308 3-.718 7h11.047l-.919-7h-9.41Zm-.89 8.675.018-.175h11.398l.078.588a1.25 1.25 0 0 1-1.24 1.412H8.373a3.485 3.485 0 0 0 .623-1.825Zm-1.497-.108-.015.146a.757.757 0 0 0-.004.07 2 2 0 0 1-3.975-.422.76.76 0 0 0 .011-.074l.013-.127a2 2 0 0 1 3.97.407Zm.28-2.724a3.484 3.484 0 0 0-1.913-.824 3.483 3.483 0 0 0-2.06.417L4.74 5.29v-.001a2 2 0 1 1 3.978.42l-.938 9.135Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgYogaStudio;
